import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { DynamicFieldsService } from '../dynamic-fields.service';
import * as _ from 'lodash';

@Component({
  selector: 'dynfield-textarea',
  template: require('./dynamic-fields.textarea.component.html')
})
export class DynamicFieldTextareaComponent implements OnChanges {
  @Input() version: any;
  @Input() field: any;
  @Input() fieldsOptions: any;
  @Input() fieldError: any;
  @Input() allowUpdate: any;

  public error: { hasError: boolean; error?: string } = { hasError: false };
  public rows: any;
  public isRequired: any;
  public content: string;

  constructor(
    private dynamicFieldsService: DynamicFieldsService
  ) {}

  ngOnInit() {
    this.error = this.dynamicFieldsService.setError(this.fieldError, this.field);
    this.content = this.field.fieldData || '';
    this.rows = this.dynamicFieldsService.getFieldOptionValue(
      this.fieldsOptions, this.field, 'attribute1', 10
    );
    this.isRequired = this.dynamicFieldsService.isRequired(this);
    if (this.field.id == 0) {
      this.field.fieldData = this.dynamicFieldsService.getFieldOptionValue(
        this.fieldsOptions, this.field, 'defaultValue', ''
      );
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (_.get(changes, 'fieldError.currentValue', false)) {
      this.error = this.dynamicFieldsService.setError(this.fieldError, this.field);
    }
  }

  onTextUpdate(data: string) {
    this.field.fieldData = data;
    _.set(this.error, 'hasError', false);
  }
}
